import React from "react";
import { Box } from "@material-ui/core";

import ClarityTree from "assets/clarity-tree.svg";
import ConnectednessTree from "assets/connectedness-tree.svg";
import EmotionalBalanceTree from "assets/emotional-balance-tree.svg";
import EmergingFactorTree from "assets/emerging-factor-tree.svg";
import { StyledGrid } from "components/simple";
import { InfoCardWrapper } from "../ScoreHistory/styled";
import { fontFamily, fontSize, spacingDefaults } from "style/constants";
import { getFactorColor } from "../BHIChart/radar";
import { PillarName } from "models/score";
import { convertToTitleCase } from "utils/misc";

interface FactorCardHeaderProps {
  score: number;
  selectedFactor: PillarName;
}

export const getFactorTree = (factor?: PillarName) => {
  switch (factor) {
    case PillarName.CLARITY:
      return ClarityTree;
    case PillarName.CONNECTEDNESS:
      return ConnectednessTree;
    case PillarName.EMOTIONAL_BALANCE:
      return EmotionalBalanceTree;
    case PillarName.EMERGING_FACTOR:
      return EmergingFactorTree;
  }
};

const FactorCardHeader: React.FC<FactorCardHeaderProps> = ({ score, selectedFactor }) => {
  return (
    <StyledGrid container padding={`${spacingDefaults.normal} 0`}>
      <StyledGrid item width="100%" textAlign="center">
        <InfoCardWrapper>
          <StyledGrid
            container
            alignItems="center"
            justifyContent="center"
            style={{ gap: spacingDefaults.xlarge }}
          >
            <StyledGrid item>
              <img src={getFactorTree(selectedFactor)} height="100px" />
            </StyledGrid>
            {selectedFactor === PillarName.EMERGING_FACTOR ? (
              <StyledGrid item>
                <StyledGrid
                  container
                  centerContent
                  direction="column"
                  style={{ gap: spacingDefaults.small }}
                >
                  <Box fontFamily={fontFamily.secondary} fontSize={fontSize.large}>
                    {convertToTitleCase(selectedFactor)}
                  </Box>
                </StyledGrid>
              </StyledGrid>
            ) : (
              <StyledGrid item>
                <StyledGrid
                  container
                  centerContent
                  direction="column"
                  style={{ gap: spacingDefaults.small }}
                >
                  <Box fontFamily={fontFamily.secondary} fontSize={fontSize.large}>
                    {convertToTitleCase(selectedFactor)}
                  </Box>
                  <Box
                    fontFamily={fontFamily.primary}
                    fontSize={fontSize.header}
                    fontWeight="600"
                    color={getFactorColor(selectedFactor)}
                  >
                    {score}
                  </Box>
                </StyledGrid>
              </StyledGrid>
            )}
          </StyledGrid>
        </InfoCardWrapper>
      </StyledGrid>
    </StyledGrid>
  );
};

export default FactorCardHeader;
